// extracted by mini-css-extract-plugin
module.exports = {"Active":"GroupManagement_Active__2VksB","Pending":"GroupManagement_Pending__3wwkF","Inactive":"GroupManagement_Inactive__3u2Wr"};